module.exports = __webpack_public_path__ + "static/media/logo.da460b92.svg";